import './Skeleton.css';

export function SkeletonBox(props) {
  var style = {
    width: props.width || '100%',
    height: props.height || '20px',
    borderRadius: props.radius || '4px',
  };
  return <div className="skeleton-box" style={style} />;
}

export function ProductCardSkeleton() {
  return (
    <div className="skeleton-product-card">
      <div className="skeleton-box" style={{ height: 'auto', aspectRatio: '4 / 5', borderRadius: '2px' }} />
      <div style={{ padding: '16px 2px' }}>
        <div className="skeleton-box" style={{ width: '40%', height: '10px', marginBottom: '8px' }} />
        <div className="skeleton-box" style={{ width: '70%', height: '14px', marginBottom: '6px' }} />
        <div className="skeleton-box" style={{ width: '50%', height: '10px', marginBottom: '10px' }} />
        <div className="skeleton-box" style={{ width: '30%', height: '14px' }} />
      </div>
    </div>
  );
}

export function HomePageSkeleton() {
  return (
    <div className="skeleton-page">
      <div className="skeleton-box" style={{ height: '300px', borderRadius: 0 }} />
      <div className="skeleton-box" style={{ height: '4px', borderRadius: 0 }} />
      <div className="skeleton-box" style={{ height: '48px', borderRadius: 0 }} />
      <div className="container">
        <div style={{ padding: 'var(--section-space) 0 48px', textAlign: 'center' }}>
          <div className="skeleton-box" style={{ width: '120px', height: '10px', margin: '0 auto 14px' }} />
          <div className="skeleton-box" style={{ width: '260px', height: '26px', margin: '0 auto' }} />
        </div>
        <div className="skeleton-grid">
          <ProductCardSkeleton />
          <ProductCardSkeleton />
          <ProductCardSkeleton />
        </div>
      </div>
    </div>
  );
}